import type {BaseComponentConfig} from "@gamzix/slot_core";

class FeatureSplashScreen extends SlotGame.src.component.BaseComponent {

    protected isShowing = false;
    protected timeToSkipFSS: number = 30000;
    protected animContainer;

    protected isShowNextTime = JSON.parse(game.localStorage.getItem("doNotShowFSS"));
    protected isFirstTimeClicked = game.localStorage.getItem("doNotShowFSS") === null;
    constructor(config: BaseComponentConfig) {
        super(config);
        this.status_checkers = {
            ...super.getStatusCheckers(),

            isShowing: () => this.isShowing,
            isClicked: () => this.isShowNextTime
        };
    }
    override onGameReady() {
        super.onGameReady();
        this.animContainer = game.tree.findByName("featureSplashScreen.intro_popup_container_spine");
    }

    async show() {
        this.isShowing = true;
        this.onChangeOrientation();
        this.animContainer.options.visible= true;
        this.animContainer.playAnimation('idle', true);
    }

    async hide() {
        const fssPopup =  game.tree.findByName("featureSplashScreen.intro_popup_container");
        await game.utils.GameUtils.playAlphaAnimation(fssPopup, {from: 1, to: 0, time: 300, timeWait: 0});

        this.isShowing = false;
        this.animContainer.options.visible = false;
        this.animContainer.stop();
        this.onChangeOrientation();
    }
    async onShowFeatureSplashScreenPopup() {
        await this.show();
        this.createBtn();
        setTimeout(() => {
            preloader.hide()
        }, 0)

        await Promise.race(
            [
                game.onceDataPromise('Button.clicked', {
                    component: 'featureSplashScreen',
                    name: 'featureSplashScreen.intro_popup_container.continue_btn'
                }),
                game.utils.delay(this.timeToSkipFSS)
            ]);
        await this.hide()
    }

    clickNextTimeBtn(): any {
        this.isShowNextTime = !this.isShowNextTime;
        game.localStorage.setItem("doNotShowFSS",  this.isShowNextTime);
        this.onChangeOrientation();
    }

    createBtn() {
        const btn =  game.tree.findByName("featureSplashScreen.intro_popup_container.do_not_show");
        btn.on('clicked', () => this.clickNextTimeBtn());
    }

    getFSMHandlers(): any {
        return {
            ...super.getFSMHandlers(),
            START: {
                ...super.getFSMHandlers()['START'],
                showFeaturesSplashScreen: {
                    on: () =>  this.onShowFeatureSplashScreenPopup(),
                    check:() =>  this.isFirstTimeClicked === true || JSON.parse(game.localStorage.getItem("doNotShowFSS")) !== true
                }
            },
        }
    }
}

export {FeatureSplashScreen};

//@ts-ignore
Game.src.component.FeatureSplashScreen = FeatureSplashScreen;